module.exports = __webpack_public_path__ + "static/media/daniel-olahhOld2.2f83071f.jpg";